import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-wrench-icon',
  imports: [],
  templateUrl: './wrench-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './wrench-icon.component.scss',
})
export class WrenchIconComponent {}
